import React, { memo, useEffect, useMemo, useCallback, useRef } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import 'typeface-roboto'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
//import CookieConsent from 'react-cookie-consent'
//import { useTranslation } from 'react-i18next'
import ReactGA from 'react-ga'
import 'antd/dist/antd.css'

import { Header, Loading } from 'components'
import {
	Index,
	Search,
	Auth,
	Create,
	Company,
	Profile,
	Team,
	AddCompany,
	CompanySettings,
	CreateStory,
	JobProfile,
	JobCreation,
	TermsAndConditions,
	UserOnboardingCreation,
	StudentsKit,
	StudentsKitEmailConfirmed,
	UpdateProfileEmail,
	Privacy,
	ChillPack,
	ChillPackEmailConfirmed,
	Varify,
} from 'screens'
import { AppProvider, StoreValue } from 'store'
import { EAppStateActionTypes } from 'models'
import { NoMatch, PrivateRoute, GuestRoute } from './routes'
import 'assets/scss/index.scss'
import { Companies, Jobs } from './screens/search/components'
import { useCheckCredentialsQuery } from './graphql/__generated__/graphql'
import { supabase } from './utils/supabase'
import { useTranslation } from 'react-i18next'

toast.configure()

function usePageViews(prevLocation: any) {
	let location = useLocation()
	useEffect(() => {
		if (prevLocation.current.pathname !== location.pathname) {
			ReactGA.pageview(location.pathname)
			prevLocation.current = { pathname: location.pathname }
		}
	}, [location, prevLocation])
}

const AppView: React.FunctionComponent<any> = memo(
	({ firebase, firebaseUser, storeDispatch, credentialsState, values }) => {
		const [queryLoading, setQueryLoading] = React.useState(true)
		const prevLocation = useRef({ pathname: '' })
		usePageViews(prevLocation)
		const { i18n } = useTranslation()
		const router = useHistory()
		// const { data, loading: queryLoading } = useQuery(
		// 	CheckCredentialsQuery,
		// 	{
		// 		fetchPolicy: 'network-only',
		// 	},
		// )

		// const token = localStorage.getItem('sb-vmmczjcmawxzvoswwuvs-auth-token')

		const { refetch } = useCheckCredentialsQuery({
			fetchPolicy: 'network-only',
			variables: {
				token: '' as never,
			},
			skip: true,
		})

		const firebaseApp: any = useMemo(
			() => (firebase && firebase.instance) || null,
			[firebase],
		)

		const handleCredentialsState = useCallback(() => {
			storeDispatch({
				type: EAppStateActionTypes.setCheckCredentials,
				checkCredentials: true,
			})
		}, [storeDispatch])

		useEffect(() => {
			supabase.auth.onAuthStateChange(async (event, session) => {
				if (
					(event === 'SIGNED_IN' || event === 'INITIAL_SESSION') &&
					session?.user
				) {
					const { data } = await refetch({
						// @ts-ignore
						token: session?.access_token,
					})

					if (!data?.checkCredentials) {
						setQueryLoading(false)
						router.push(`/${i18n.language}/auth/signUp?step=1`)
					} else {
						storeDispatch({
							type: EAppStateActionTypes.updateUser,
							user: data?.checkCredentials || null,
						})
						handleCredentialsState()
						setQueryLoading(false)

						if (
							window.location.pathname ===
							`/${i18n.language}/auth/signUp`
						) {
							// Redirect to the home page if the user is signed in
							router.push(`/${i18n.language}`)
						}
					}
				} else if (event === 'SIGNED_OUT') {
					// console.log('supabase auth state change', event, session)
					storeDispatch({
						type: EAppStateActionTypes.updateUser,
						user: null,
					})
					handleCredentialsState()
					// mixpanel.reset()
					setQueryLoading(false)
				} else {
					setQueryLoading(false)
				}
			})
			// supabase.auth.getUser().then(({ data, error }) => {
			// 	console.log('supabase user', data?.user, error)
			// 	// if (
			// 	// 	!queryLoading &&
			// 	// 	token &&
			// 	// 	(!data?.checkCredentials?.profileCollection?.edges?.[0]
			// 	// 		?.node?.firstName ||
			// 	// 		!data?.checkCredentials?.profileCollection?.edges?.[0]
			// 	// 			?.node?.lastName)
			// 	// ) {
			// 	// 	storeDispatch({
			// 	// 		type: EAuthActionTypes.incrementStep,
			// 	// 	})
			// 	// 	setTimeout(() => {
			// 	// 		router.push(`/${i18n.language}/auth/signUp?step=1`)
			// 	// 	}, 500)
			// 	// 	// return undefined
			// 	// } else {
			// 	storeDispatch({
			// 		type: EAppStateActionTypes.updateUser,
			// 		user: data?.user || null,
			// 	})
			// 	handleCredentialsState()
			// 	// }
			// })
			// if (!data || queryLoading) return undefined
			// if (typeof data.checkCredentials === 'undefined') return undefined
		}, [
			handleCredentialsState,
			firebaseApp,
			firebaseUser,
			storeDispatch,
			refetch,
			i18n.language,
			router,
		])

		// useEffect(() => {
		// 	// when CheckCredentialsQuery is excuted, I will set 'checkCredentials' state's value with 'true' in global store.
		// 	// 'checkCredentials' state indicate if CheckCredentialsQuery was executed or not.
		// 	if (!data || queryLoading) return undefined
		// 	if (typeof data.checkCredentials === 'undefined') return undefined
		// 	handleCredentialsState()
		// }, [data, queryLoading, handleCredentialsState])

		return queryLoading ? (
			<Loading size={48} />
		) : (
			<>
				<Header />
				<div className={'wrapper'}>
					<Switch>
						<GuestRoute
							path="/:language(en|ro)/auth/:section(login|signUp|forgotPassword)?/:token?"
							component={Auth}
						/>
						<GuestRoute
							path="/oauth/:provider(facebook|linkedin|google)"
							component={Auth}
						/>
						<GuestRoute path="/verify/:token" component={Varify} />
						<PrivateRoute
							path="/:language(en|ro)/people/:personID/settings/update-email/:token"
							component={UpdateProfileEmail}
						/>

						<Route path="/:language(en|ro)" exact>
							<Index />
						</Route>
						<PrivateRoute
							path="/:language(en|ro)/user-onboarding"
							component={UserOnboardingCreation}
						/>
						<Route path="/:language(en|ro)/articles/post-:postId">
							<Index />
						</Route>
						<Route path="/:language(en|ro)/articles/:articleSlug">
							<Index />
						</Route>
						<Route
							path="/:language(en|ro)/search/:searchSection(all|employers|people|articles|teams|jobs)?"
							exact
						>
							<Search />
						</Route>
						<Route path="/:language(en|ro)/search/:searchSection(all|articles)/post-:postId">
							<Search />
						</Route>
						<Route path="/:language(en|ro)/search/:searchSection(all|articles)/:articleSlug">
							<Search />
						</Route>
						<Route
							path="/:language(en|ro)/employers/:companySlug/:companySection(teams|posts)"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/teams/:teamSlug"
							exact={true}
							component={Team}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/create-story"
							component={CreateStory}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/:companySection/post-:postId"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/:companySection/:articleSlug"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/story/post-:postId"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/story/:articleSlug"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug"
							exact={true}
							component={Company}
						/>
						<Route
							path="/:language(en|ro)/employers"
							render={props => (
								<Companies {...props} showCompanies={true} />
							)}
							exact={true}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/company-settings"
							component={CompanySettings}
							exact={true}
						/>
						<Route
							path="/:language(en|ro)/people/:personID/:profileSection/post-:postId"
							exact={true}
							component={Profile}
						/>
						<Route
							path="/:language(en|ro)/people/:personID/:profileSection/:articleSlug"
							exact={true}
							component={Profile}
						/>
						<Route
							path="/:language(en|ro)/people/:personID/:profileSection(posts|settings)?"
							exact={true}
							component={Profile}
						/>
						<Route
							path="/:language(en|ro)/create-company"
							component={AddCompany}
						/>
						<Route
							path="/:language(en|ro)/:companySlug/jobs/:action(edit|create)/:jobSlug?/:jobId?"
							component={JobCreation}
						/>
						<Route
							path="/:language(en|ro)/:companySlug/jobs/:jobSlug/:jobId"
							component={JobProfile}
							exact={true}
						/>
						<Route
							path="/:language(en|ro)/jobs"
							render={props => (
								<Jobs {...props} showJobs={true} />
							)}
							exact={true}
						/>
						<Route
							path="/:language(en|ro)/employers/:companySlug/active-jobs"
							render={props => (
								<Jobs {...props} showJobs={true} />
							)}
						/>
						<PrivateRoute
							path="/:language(en|ro)/(create|edit)"
							component={Create}
						/>
						<Route
							path="/:language(en|ro)/studentsKit2023/confirmedEmail"
							component={StudentsKitEmailConfirmed}
							exact={true}
						/>
						<Route
							path="/studentsKit2023"
							component={StudentsKit}
							exact={true}
						/>
						<Route
							path="/cp2022"
							component={ChillPack}
							exact={true}
						/>
						<Route
							path="/cp2022/confirmedEmail"
							component={ChillPackEmailConfirmed}
							exact={true}
						/>
						<Route
							path="/:language(en|ro)/terms_and_conditions"
							component={TermsAndConditions}
						/>
						<Route
							path="/:language(en|ro)/privacy"
							component={Privacy}
						/>
						<Route component={NoMatch} />
					</Switch>
				</div>
				{/* <CookieConsent>
					{t(
						'We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are happy with it.',
					)}
				</CookieConsent> */}
			</>
		)
	},
)

const App: React.FunctionComponent<{}> = memo(() => (
	<StoreValue
		keys={[
			'firebase',
			'firebaseUser',
			'storeDispatch',
			'user',
			'credentialsState',
			'values',
		]}
	>
		<AppView />
	</StoreValue>
))

export default memo(() => (
	<AppProvider>
		<App />
	</AppProvider>
))
